import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Auth, user } from '@angular/fire/auth';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-not-found-redirect',
    template: '',
    standalone: false
})
export class NotFoundRedirectComponent implements OnInit {
  constructor(private auth: Auth, private router: Router) { }

  ngOnInit() {
    const attemptedUrl = this.router.url;

    user(this.auth).pipe(take(1)).subscribe(currentUser => {
      if (currentUser) {
        this.router.navigate(['/not-found'], { replaceUrl: true, state: { attemptedUrl } });
      } else {
        this.router.navigate(['/error'], { replaceUrl: true, state: { attemptedUrl } });
      }
    });
  }
}
